import { makeParquetQuerier } from "./parquetQuery";
import { matchesRange } from "./rangeMatch";

const queryParquet = makeParquetQuerier("Labyrinth-LTG");

function getAgeColumn(age) {
  if (age >= 55 && age <= 69) return "age_55_69";
  if (age >= 70 && age <= 79) return "age_70_79";
  if (age >= 80 && age <= 95) return "age_80_95";
  return null;
}

/**
 * Look up the LT-G norm row for a given raw time and patient age.
 * Source: Tab. 2.5 LT-G-Normen für Personen mit selbständiger Haushaltsführung.
 * @param {number} age - patient age (55-95)
 * @param {string|number} temps - raw time in seconds
 * @returns {Promise<{pr: string, c: number, sw: number, iq: number} | {error: string}>}
 */
export async function calcLabyrinthPC(age, temps, lang) {
  const col = getAgeColumn(age);
  if (!col) {
    return {
      error: lang === "de"
        ? `Alter ${age} außerhalb des Bereichs (55-95)`
        : `Âge ${age} hors plage (55-95)`,
    };
  }

  const t = parseFloat(temps);
  if (isNaN(t)) return { error: lang === "de" ? "Ungültige Zeit" : "Temps invalide" };

  const rows = await queryParquet("ltg-normen-haushalt.parquet");
  const row = rows.find((r) => matchesRange(t, r[col]));
  if (!row) {
    return {
      error: lang === "de"
        ? `Keine Übereinstimmung für Zeit=${t}", Alter=${age}`
        : `Aucune correspondance pour temps=${t}", âge=${age}`,
    };
  }

  return { pr: row.pr, c: row.c, sw: row.sw, iq: row.iq };
}
